<script setup lang="ts">
import parsePhoneNumber from 'libphonenumber-js'
import { Phone } from 'lucide-vue-next'
import { computed } from 'vue'

const props = defineProps<{
  phoneNumber?: string
  prefix?: string
  simple?: boolean
}>()

const formattedNumber = computed(() => {
  const parsed = parsePhoneNumber(props.phoneNumber || '', 'NO')

  return {
    formatted: parsed?.formatNational(),
    prefix: parsed?.countryCallingCode,
  }
})
</script>
<template>
  <span class="" v-if="props.phoneNumber">
    <Phone :size="16" class="shrink-0" v-if="!props.simple" />
    <span>
      <span v-if="props.prefix || formattedNumber.prefix" class="text-gray-500 text-xs">
        (+{{ Number(props.prefix) || formattedNumber.prefix }}) </span
      >{{ formattedNumber.formatted }}</span
    >
  </span>
  <!-- <span v-else class="italic text-gray-500 text-sm">No phone number</span> -->
  <span v-else class="text-red-400">
    <!-- <CircleX :size="16" />  -->
    <span class="text-gray-400 text-sm">No value</span>
  </span>
</template>
